import { createSelector } from 'reselect';
import metadataFieldsSelector from './metadataFields';

const DEFAULT = {};

export default createSelector(
  metadataFieldsSelector,
  metadataFields => metadataFields.Route || DEFAULT
);
